module.exports = __webpack_public_path__ + "img/close.62e90ec8.svg";